import * as React from 'react';

import type { IconSize } from 'bundles/ai-course-coach/assets/iconTypes';

/**
 * Rebrand MUI icon for Chevron down
 */
const ChevronDownIconV2 = ({ size = 16, className }: { size?: IconSize; className?: string }) => (
  <svg
    width={size}
    height={size}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.00774 12.0932C7.84905 12.0932 7.71019 12.0684 7.59118 12.0188C7.47216 11.9692 7.36306 11.8849 7.26388 11.7659L1.34277 5.84477C1.10474 5.62657 0.990677 5.37366 1.0006 5.08603C1.01051 4.79841 1.12457 4.5455 1.34277 4.3273C1.56097 4.1091 1.81884 4 2.11638 4C2.41393 4 2.68171 4.1091 2.91975 4.3273L8.00774 9.44504L13.1255 4.3273C13.3437 4.1091 13.5966 4 13.8842 4C14.1718 4 14.4347 4.1091 14.6727 4.3273C14.8909 4.56533 15 4.83312 15 5.13066C15 5.42821 14.8909 5.68608 14.6727 5.90428L8.78135 11.7659C8.66233 11.8849 8.54331 11.9692 8.4243 12.0188C8.30528 12.0684 8.16643 12.0932 8.00774 12.0932Z"
      fill="#1E2229"
    />
  </svg>
);

export default ChevronDownIconV2;
